import produce from "immer";
import {
  ADD_COMMENT,
  ADD_COMMENT_FAILURE,
  ADD_COMMENT_SUCCESS,
  //
  DELETE_COMMENT,
  DELETE_COMMENT_FAILURE,
  DELETE_COMMENT_SUCCESS,
  //
  EDIT_COMMENT,
  EDIT_COMMENT_FAILURE,
  EDIT_COMMENT_SUCCESS,
  //
  FETCH_COMMENTS,
  FETCH_COMMENTS_FAILURE,
  FETCH_COMMENTS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SET_COMMENT_FILTERS,
  //
  TOGGLE_COMMENT_EDIT,
} from "./constants";

export const initialState = {
  isFetchingComments: false,
  comments: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentComment: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  commentFilters: {
    page: 1,
    limit: 10,
    feed_id: "",
  },
  //
  commentCardMode: false,
};

const CommentReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_COMMENTS:
        draft.isFetchingComments = true;
        break;
      case FETCH_COMMENTS_SUCCESS:
        draft.isFetchingComments = false;
        draft.comments = action.payload;
        break;
      case FETCH_COMMENTS_FAILURE:
        draft.isFetchingComments = false;
        draft.comments = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentComment = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentComment = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentComment = {};
        break;
      // Add
      case ADD_COMMENT:
        draft.isSubmitting = true;
        break;
      case ADD_COMMENT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_COMMENT_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_COMMENT:
        draft.isSubmitting = true;
        break;
      case EDIT_COMMENT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_COMMENT_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_COMMENT:
        draft.isDeleting = true;
        break;
      case DELETE_COMMENT_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_COMMENT_FAILURE:
        draft.isDeleting = false;
        break;
      // Set Filters
      case SET_COMMENT_FILTERS:
        draft.commentFilters = action.payload;
        break;
      // Toggle Edit
      case TOGGLE_COMMENT_EDIT:
        draft.commentCardMode = action.payload;
        break;
      default:
        return state;
    }
  });

export default CommentReducer;
